import React from "react";
import AdminGamergyOps from "../admin/AdminGamergyOps";

export default function TournamentOpsGamergy() {
  const pathParts = window.location.pathname.split("/").filter(Boolean);
  const selectedGame = pathParts[2] ? decodeURIComponent(pathParts[2]) : "";
  const isGameWorkspace = Boolean(selectedGame);

  return (
    <AdminGamergyOps
      apiPath="/api/tournament-ops/gamergy-intake"
      visualVariant="handshake"
      enableFreeAgentTeamBuilder
      enableExtendedBracketModes
      badgeLabel="Panel de Torneos"
      pageTitle={isGameWorkspace ? "Operación de torneo Gamergy" : "Selecciona el juego a administrar"}
      pageDescription={
        isGameWorkspace
          ? "Aquí trabajas solo el juego seleccionado: registros, check-in, cupos y brackets sin mezclarte con los demás títulos."
          : "Primero elige el título que vas a correr. Después entras a un workspace dedicado de ese juego con todo lo operativo."
      }
      primaryLinks={[
        { href: "/tournament-ops/gamergy", label: "Todos los títulos" },
      ]}
      initialGame={selectedGame || "all"}
      lockGameSelection={isGameWorkspace}
      showGameSelectionScreen={!isGameWorkspace}
      gameRouteBase="/tournament-ops/gamergy"
    />
  );
}
